import React, { useEffect, useState } from 'react';
import last from 'ramda/src/last';
import Button from '@components/@core/AnimatedButton';
import QuillEditor from '@components/@core/QuillEditor';

const EmployeeComments = ({ completed = false, comments, onComment = () => {}, onCheckout = () => {} }) => {
    const [comment, setComment] = useState(null);

    useEffect(() => {
        setComment(comments ? last(comments)?.comment : null);
    }, [comments]);

    return (
        <>
            <p className="dsl-b18 bold">Daily Notes</p>
            {completed ? (
                <div className="h-100 border-top border-bottom">
                    {comment ? <div className="dsl-b16 mt-3" dangerouslySetInnerHTML={{ __html: comment }} /> : <p className="dsl-b16 mt-3">No user notes saved</p>}
                </div>
            ) : (
                <>
                    <QuillEditor className="mb-3 overflow-hidden" value={comment} placeholder="Share your analysis on the wins and losses of the day." onChange={(e) => setComment(e)} />
                    <div className="d-flex jc-end ai-center">
                        <Button className="mr-2" type="low" name="Save Draft" onClick={() => onComment(comment)} />
                        <Button name="Checkout" onClick={() => onCheckout(comment)} />
                    </div>
                </>
            )}
        </>
    );
};

export default EmployeeComments;
